export default "__VITE_ASSET__7caa2f00__"